/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.romanticcollection = {
    attach: function (context, settings) {
      const $dropdown = $('.dropdown', context);
      const $dropdownToggle = $('.dropdown-toggle', context);
      const $dropdownMenu = $('.dropdown-menu', context);
      const showClass = 'show';

      $(window).on('load resize', function () {
        if (window.matchMedia('(min-width: 1200px)').matches) {
          $dropdown.on({
            mouseenter: function () {
              const $this = $(this);
              $this.addClass(showClass);
              $this.find($dropdownToggle).addClass(showClass).attr('aria-expanded', 'true').attr('aria-haspopup', 'true').attr('data-bs-toggle', 'dropdown-click').attr('data-bs-popper', 'none');
              $this.find($dropdownMenu).addClass(showClass);
            },
            mouseleave: function () {
              const $this = $(this);
              $this.removeClass(showClass);
              $this.find($dropdownToggle).removeClass(showClass).attr('aria-expanded', 'false').attr('aria-haspopup', 'false').attr('data-bs-toggle', 'dropdown').attr('data-bs-popper', 'none');
              $this.find($dropdownMenu).removeClass(showClass);
            }
          });
        } else {
          $dropdown.off('mouseenter mouseleave');
        }
      });

      $('[data-bs-toggle="tooltip"]', context).each(function () {
        const $element = $(this);
        if (!$element.data('tooltip-initialized')) {
          new bootstrap.Tooltip(this);
          $element.data('tooltip-initialized', true);
        }
      });

    }
  };

})(jQuery, Drupal);
